import { apiFetch } from './apiClient';

export function askCortex(message, thread = {}) {
  return apiFetch('/api/chat', {
    method: 'POST',
    body: JSON.stringify({
      message,
      threadId: thread.threadId ?? undefined,
      parentMessageId: thread.parentMessageId ?? undefined,
    }),
  });
}
